import { Histogram } from './Histogram';
import { ReportActions, ReportActionData } from './ReportActions';
import { Report } from '../../types/report.types';
import { DataSet, ColumnId } from '../../types';
import { getColumnNameById } from '../utils/column-utils';

/**
 * HistogramWithReportActions - レポート機能付きヒストグラム
 *
 * ヒストグラムにレポート作成・追加機能を合成したコンポーネント。
 * - 右クリックでコンテキストメニューから追加可能
 */

interface HistogramWithReportActionsProps {
  data: number[];
  width?: number;
  height?: number;
  bins?: number;
  title?: string;
  onBinClick?: (minValue: number, maxValue: number, dataIndices: number[], isAdditive?: boolean) => void;
  originalData?: { value: number; index: number }[];
  selectedIndices?: number[];
  // レポート機能用
  columnName: ColumnId;
  dataset: DataSet;
  availableReports: Report[];
  onAddToReport: (reportId: string, data: ReportActionData) => void;
  onCreateNewReport: (data: ReportActionData) => void;
  // 密度推定表示用のプロパティ
  showDensity?: boolean;
  densityBandwidth?: number;
}

export function HistogramWithReportActions({
  data,
  width,
  height,
  bins = 10,
  title,
  onBinClick,
  originalData,
  selectedIndices,
  columnName,
  dataset,
  availableReports,
  onAddToReport,
  onCreateNewReport,
  showDensity,
  densityBandwidth
}: HistogramWithReportActionsProps) {
  // 列IDから列名を取得してタイトルに使用
  const actualColumnName = getColumnNameById(dataset, columnName) || columnName;

  // ヒストグラム用のアクションデータを作成
  const actionData: ReportActionData = {
    type: 'histogram',
    title: `Histogram: ${actualColumnName}`,
    histogramData: {
      columnName,
      dataset,
      bins
    }
  };

  return (
    <ReportActions
      availableReports={availableReports}
      onAddToReport={onAddToReport}
      onCreateNewReport={onCreateNewReport}
      actionData={actionData}
    >
      <Histogram
        data={data}
        width={width}
        height={height}
        bins={bins}
        title={title}
        onBinClick={onBinClick}
        originalData={originalData}
        selectedIndices={selectedIndices}
        showDensity={showDensity}
        densityBandwidth={densityBandwidth}
      />
    </ReportActions>
  );
}